// extracted by mini-css-extract-plugin
export default {"cell-container":"CellDeployModuleName_cell-container__pJhh1","cell-name":"CellDeployModuleName_cell-name__2E-v7"};